import axios from "axios";
//import { proxyServer } from "../assets/constantes";
import {proxyServer} from "../assets/constantes";


export const getSaludo = async () => {
  
  try {
    let saludo = await axios.get(`${proxyServer}api/saludo`);
    console.log(saludo);
    return saludo
  } catch (error) {
    console.log(error);
    return error
  }
};

export const newUserByFormAptosVetex = async (data)=> {
  
  

  try {
    let result = await axios.post(`${proxyServer}api/newFlowCreateUserByForm`,data); 
    //console.log(result);
    return result
  } catch (error) {
    console.log(error);
    return error
  }
}

export const getDataCLMFClientVtexByEmail = async (email)=>{
  

  try {
    //const origin = window.location.origin;
    //console.log('origin:..',origin);
    
    let result = await axios.get(`${proxyServer}api/getDataCLMFClientVtex/${email}`);
    console.log(result);
    return result
  } catch (error) {
    console.log(error);
    return error
  }
}

export const getFindClientAptosByEmail = async (email) =>{
  
  try {
    //const origin = window.location.origin;
    //console.log('origin:..',origin);
    //axios.defaults.headers.common['origin'] = origin;
    let result = await axios.get(`${proxyServer}api/getFindClientAptosByEmail/${email}`);
    console.log(result);
    return result
  } catch (error) {
    console.log(error);
    return error
  }
}

export const sendEmailConfirmCode = async (email)=>{
  
  const body = {
    emailUser: email
  }
  console.log('Enviando codigo al user:..',email,' proxyServer:..',proxyServer)
  try {
    let result = await axios.post(`${proxyServer}api/sendEmailConfirmCode`,body);
    console.log(result);
    return result
  } catch (error) {
    console.log('Error al En el servicio de envio del codigo de acceso:...',error);
    return error
  }

}

export const generalReportUsers = async ()=>{
  try {
    //const origin = window.location.origin;
    //console.log('origin:..',origin);
    //axios.defaults.headers.common['origin'] = origin;
    let result = await axios.get(`${proxyServer}api/generalReportUsers`);
    console.log(result);
    return result
  } catch (error) {
    console.log(error);
    return error
  }
}

export const getDataClientByEmailInDB = async (email)=>{
  
  try {
    //agregaremos el origin a los headers extrayendolo del window.location.origin
    ///const origin = window.location.origin;
    //axios.defaults.headers.common['origin'] = origin;
    //console.log('origin:..',origin);

    let result = await axios.get(`${proxyServer}api/getDataClientByEmailInDB/${email}`);
    console.log(result);
    return result
  } catch (error) {
    console.log(error);
    return error
  }
}

export const getDataClientAptosByEmail = async (email)=>{
  
  try {
    const origin = window.location.origin;
    //axios.defaults.headers.common['origin'] = origin;
    //console.log('origin:..',origin);
    let result = await axios.get(`${proxyServer}api/getDataClientAptosByEmail/${email}`);
    console.log(result);
    return result
  } catch (error) {
    console.log(error);
    return error
  }
}